import { Component, OnInit, ElementRef, Input, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { SystemDefaultModel, ChineseDefaultModel, EnglishDefaultModel } from 'src/app/models/non-master-model/SystemDefaultModel';
import { tConsultHeadModelWithPatientInfo } from 'src/app/models/tConsultHeadModel';
import { NavigationComponent } from 'src/app/pages/navigation/navigation.component';
import { isNullOrUndefined } from 'util';
import { tConsultCertModel, tConsultCertModelPrint } from 'src/app/models/tConsultCertModel';
import { DateTimeConvertService } from 'src/app/services/CommonService/DateTimeConvert.service';
import { tOnConsultService } from 'src/app/services/tOnConsult.service';
import { tEmployeeService } from 'src/app/services/tEmployee.service';
import { GenderModel } from 'src/app/models/SimpleConfigModel';

import { MatTableDataSource, ShowOnDirtyErrorStateMatcher } from '@angular/material';
import { DatePipe } from '@angular/common';
import { AppSettings } from 'src/app/shared/AppSettings';
import { SimpleConfigService } from 'src/app/services/SimpleConfig.service';
import { Gender } from 'src/app/models/non-master-model/Gender';

import { tShopService } from 'src/app/services/tShop.service';
import { tPatientService } from 'src/app/services/tPatient.service';
import { CrypService } from 'src/app/services/Non-Master/Cryp.service';
import { tBillPayService } from 'src/app/services/tBillPay.service';
import { tBillPayModel, BillPay_ItemType } from 'src/app/models/tBillPayModel';
import { UnitItemService } from 'src/app/services/Unit/UnitItem.service';
import { UnitItemModel } from 'src/app/models/UnitItemModel';
@Component({
  selector: 'app-medical-report',
  templateUrl: './medical-report.component.html',
  styleUrls: ['./medical-report.component.css']
})
export class MedicalReportComponent implements OnInit {

  // @ViewChild('autoClick') autoClick: ElementRef;
 // picFullPath = './assets/img/print/doc_logo.png';
 // picFullPath_SignShop2 = './assets/img/print/signShop2.png';

 urlStartingPath = AppSettings.shopAdapter.imagePath;
 signShop2Path = this.urlStartingPath+"/assets/img/print/signShop2.png";
 picFullPath = this.urlStartingPath+"/assets/img/print/doc_logo.png";

 // picFullPath = window.location.origin + '/assets/img/print/doc_logo.png';

 isHiddenShop2Sign = false;
 isHiddenDefaultSign = false;

 TAG = 'SickLeaveCertComponent';

 isHiddenShop1Info = true;
 isHiddenShop2Info = true;

 dataList_item: tBillPayModel[];
 showEng = false;
 shopAddressEng1='';
 shopAddressEng2='';
 shopAddressEng3='';
 shopAddress1='';
 shopAddress2='';
 shopAddress3='';
 shopPhone='';
 shopEmail='';
 shopNameTC = ''; //shop chinese name

 ecName = '';
 HKIDStr='';
 @Input() action: string;
 @Input() status: string;
 @Input() tableKeyValue: string;
 @Input() msg: string;
 @Input() searchFilter: number;
 @Input() docType: number;
 @Input() genderList: GenderModel[];


 onConsultDataList: tConsultHeadModelWithPatientInfo;

 patientTitle_selection;
 patientGender_selection;

 printCertList: tConsultCertModelPrint;


 patientGender_selection_Display = '';




 constructor(
   private router: Router,
   public activeModal: NgbActiveModal,
   private tOnConsultService: tOnConsultService,
   private dateTimeConvertService: DateTimeConvertService,
   private tEmployeeService: tEmployeeService,
   public datepipe: DatePipe,
   private SimpleConfigService:SimpleConfigService,
   private tShopService: tShopService,
   private tPatientService: tPatientService,
   private CrypService: CrypService,
   private tBillPayService: tBillPayService,
   private unitItemService: UnitItemService
   ) { }

 ngOnInit() {


   this.printCertList = new tConsultCertModelPrint();

   this.setDefaultLanguageString(AppComponent.usingLanguage);
   this.onConsultDataList = JSON.parse(localStorage.getItem('onConsultModel'));
   this.ecName = this.onConsultDataList.clthTherapistName;
   this.getOnConsultInfo();

   this.getShopInfo(NavigationComponent.selectedShopID.toString());

   if (NavigationComponent.selectedShopID.toString() === '2') {
     this.isHiddenShop2Sign = false;
     this.isHiddenDefaultSign = true;
   } else {
     this.isHiddenShop2Sign = true;
     this.isHiddenDefaultSign = false;
   }


   if (NavigationComponent.selectedShopID.toString() === '2') {
     this.isHiddenShop1Info = true;
     this.isHiddenShop2Info = false;
   } else {
     this.isHiddenShop1Info = false;
     this.isHiddenShop2Info = true;
   }
   this.getAllBillData();
   //console.table(this.onConsultDataList);
   //console.table(this.printCertList);

 }
 ngAfterViewInit() {
   // let inputElement: HTMLElement = this.autoClick.nativeElement as HTMLElement;
   // setTimeout(() => {
   //   inputElement.click();
   //  // this.activeModal.close('Close click');
   //   // And any other code that should run only after 5s
   // }, 2100);
 }
 getOnConsultInfo() {
   // tslint:disable-next-line:max-line-length
   this.tOnConsultService.getOnConsultInfo(this.onConsultDataList.shopID, this.onConsultDataList.clthConsultNumber).subscribe(data => {

     this.onConsultDataList = data[0];

     for(var i = 0 ; i < this.genderList.length ; i++){

       if(this.onConsultDataList.patientGender == this.genderList[i].id){

         if(this.showEng == false){
           this.patientGender_selection_Display = this.genderList[i].chineseName +' '+ this.genderList[i].engName;

         }else{
           this.patientGender_selection_Display = this.genderList[i].engName;

         }
       }
     }

     this.loadPatientData();
     this.getSavedConsultCert();
   });

 }

 getSavedConsultCert() {
   this.tOnConsultService.getSavedConsultCert(NavigationComponent.selectedShopID.toString(),
     this.onConsultDataList.clthConsultNumber, this.onConsultDataList.patientID).subscribe((data: any) => {

       if (!isNullOrUndefined(data[0])) {
         // this.log.d(this.TAG, 'getSavedConsultCert: ' + JSON.stringify(data[0]));
         this.printCertList = data[0];

         const dbStartDate = this.dateTimeConvertService.ConvertCurrentDBDay(new Date(data[0]['startDate'].toString()));
         const dbEndDate = this.dateTimeConvertService.ConvertCurrentDBDay(new Date(data[0]['endDate'].toString()));

         const dbArrDate = this.dateTimeConvertService.ConvertCurrentDBDay(
           new Date(this.onConsultDataList.clthArrivalDateTime.toString()));


         this.printCertList.startDatePrint = dbStartDate;
         this.printCertList.endDatePrint = dbEndDate;
         this.printCertList.ArrivalDatePrint = dbArrDate;
         this.printCertList.printDate=this.dateTimeConvertService.ConvertCurrentDBDay(new Date(data[0]['prescriptionPrintDate'].toString()));



         if (!isNullOrUndefined(this.printCertList.therapistID)) {
           this.tEmployeeService.getDataById(
             1, // NavigationComponent.selectedShopID,
             this.printCertList.therapistID.toString()).subscribe(therapisdata => {

               this.printCertList.therapistName = therapisdata.employeeChiName +" "+therapisdata.employeeSurname ;
               this.printCertList.regNo1 = therapisdata.drCMP;
               this.printCertList.regNo2 = therapisdata.drRegNo;

               if (this.printCertList.regNo2 !== '006712') {
                 this.isHiddenShop2Sign = true;
               }

           });

         }
         //console.table(this.printCertList);
       }

     });
 }


 setDefaultLanguageString(language: String){
   switch(language) {
     case SystemDefaultModel.Language_Chinese:

       this.showEng = false;
       break;
     case SystemDefaultModel.Language_English:

       this.showEng = true;

       break;
     default:

       this.showEng = false;

       break;
   }
 }

 cancel() {
   // this.log.i(this.TAG, "do cancel");
   this.activeModal.close('Close click');
 }

 isShowAPM(text: any) {

   if (isNullOrUndefined(text))
   {
     return false;
   }


   return true;

 }



 changeFont(className:string, operator:string){

   console.log("doing changeFont operator = "+operator);
   let element: any;
 //  let element2: any;

     element = document.getElementById(className);

     var style = window.getComputedStyle(element, null).getPropertyValue('font-size');
     var fontSize = parseFloat(style);

     if(operator === '+'){
       element.style.fontSize = (fontSize + 1) + 'px';

     }else{
       element.style.fontSize = (fontSize - 1) + 'px';

     }

 }


 loadPatientData() {
   this.tPatientService.getDataById(NavigationComponent.selectedShopID.toString(), this.onConsultDataList.patientID).subscribe(data => {



     const patientIHKID = data.patientIHKID.toString();
     var decrypted = this.CrypService.decryptStr(patientIHKID).toString();
     this.HKIDStr=decrypted;

   });
 }

 getShopInfo(shopID: string) {
   this.tShopService.getDataById(shopID).subscribe(
     (res: any) => {
       console.log(res);
       this.shopAddressEng1=res.shopAddressEng1;
       this.shopAddressEng2=res.shopAddressEng2;
       this.shopAddressEng3=res.shopAddressEng3;
       this.shopPhone=res.shopPhone;
       this.shopAddress1=res.shopAddress1;
       this.shopAddress2=res.shopAddress2;
       this.shopAddress3=res.shopAddress3;
       this.shopEmail=res.shopEmail;
       this.shopNameTC = res.shopName;
      // this.shopFax=res.shopFax;
       // this.shopList = res;
       // this.shopName = this.shopList[0].shopName.toString();
       // console.log('shopList = ' + JSON.stringify(res));
       // console.log('shopList = ' + this.shopList[0].shopName.toString());
     },
     err => {
       console.log(err);
     },
   );
 }
 getAllunit(){
  this.dataList_item.forEach((data)=>{
    this.unitItemService.getItemUnit(data.bpItemID,data.shopID).subscribe((data2) => {
      if(data2!=null){
        data.bpPackDesc = data2.itemUnitName;
      }else{
        data.bpPackDesc = "";
      }});

  })
 }
 getAllBillData(): void {
  //   this.log.i(this.TAG, 'getAllData ');
  // this.getItemTypeInfo();

  var shopID = NavigationComponent.selectedShopID.toString();

  this.tBillPayService.getDataByShopIDAndVoucherID(shopID, this.onConsultDataList.clthBillingNumber).subscribe(data => {


    // this.log.i(this.TAG, JSON.stringify(data));

    //    this.dataList_item = data;

    //   var billVoucherData: tBillPayModel[] = data;

    this.dataList_item = new Array;

    for (var i = 0; i < data.length; i++) {
      // if (data[i].bpPaymentNumber == null) {

      //   this.dataList_item.push(data[i]);
      // } else {
      //   this.dataList_Payment.push(data[i]);
      // }
      var itemType = data[i].bpItemType;
      if (itemType == BillPay_ItemType.ITEM || itemType == BillPay_ItemType.ITEM_PACKAGE || itemType == BillPay_ItemType.PRESCRIPTION) {



        this.dataList_item.push(data[i]);


      } else if (itemType == BillPay_ItemType.PAYMENT || itemType == BillPay_ItemType.PAYMENT_VOID || itemType == BillPay_ItemType.PAYMENT_VOID_PACKAGE) {

      }
    }

    this.getAllunit();
  });


}
}
